import { Component, forwardRef, SimpleChanges, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputControlBase } from '../base/input-control-base/input-control.base';

@Component({
  selector: 'app-input-datetime-control',
  templateUrl: './input-datetime-control.component.html',
  styleUrls: ['./input-datetime-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDatetimeControlComponent),
      multi: true
    }
  ]
})
export class InputDatetimeControlComponent extends InputControlBase<Date> {
  @Input('css')
  css: string = '';

  constructor(){
    super();
  }
  protected onInit(): void {
    this.initCss();
  }  
  protected onDestroy(): void {
  }
  protected onChanges(changes: SimpleChanges): void {
  }
  protected onDoCheck(): void {
  }
  protected onAfterContentInit(): void {
  }
  protected onAfterContentChecked(): void {
  }
  protected onAfterViewInit(): void {
  }
  protected onAfterViewChecked(): void {
  }

  private initCss() {
    this.defaultCss += ` ${this.css}`;
  }
}
